"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const CoreEntity_1 = __importDefault(require("./CoreEntity"));
class Permission extends CoreEntity_1.default {
    constructor(data, connector) {
        super(connector);
        this.allowed = data.allowed;
        this.appAddress = data.appAddress;
        this.granteeAddress = data.granteeAddress;
        this.params = data.params;
        this.roleHash = data.roleHash;
    }
    async getApp() {
        return this._connector.appByAddress(this.appAddress);
    }
    async getRole() {
        const roles = await this._connector.rolesForAddress(this.appAddress);
        return roles.find(role => role.hash === this.roleHash);
    }
}
exports.default = Permission;
//# sourceMappingURL=Permission.js.map